export class VersionDto {
  major: number;
  minor: number;
  revision: number;
  label: string;

  constructor(d?: VersionDto) {
    if (!d) {
      return;
    }
    this.major = d.major;
    this.minor = d.minor;
    this.revision = d.revision;
    this.label = d.label;
  }
}
